import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    copyLinkSuccess: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            copyLinkSuccess: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCopyLink.copyLinkSuccess?c=1k437rado15he", defaultMessage: "Link copied" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
